import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { withTheme } from '@material-ui/core/styles';
import styled, { ThemeProvider } from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { getLayoutContentStackData } from 'features/layout/actions';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import Container from 'components/Container';
import CallsToAction from 'components/CallsToAction';
import FullHeightGrid from 'components/FullHeightGrid';

import SVG from 'react-inlinesvg';

const ExtendedFooterContainer = styled.div`
  padding: 50px 25px;
  background-color: ${props =>
    props.theme.palette.type === 'dark'
      ? props.theme.palette.grey[800]
      : props.theme.palette.grey[50]};
`;

const ProdFamily = styled(Grid)`
  text-align: center;
  margin-bottom: 50px;
  opacity: 0.65;
`;

const ProductIcon = styled.img`
  margin-bottom: 20px;
`;

const ProdFamilySVG = styled(SVG)`
  svg {
    width: auto;
    height: 32px;
    margin-bottom: 20px;

    path,
    g,
    polygon {
      fill: ${props =>
        props.theme.palette.type === 'dark'
          ? 'white'
          : props.theme.palette.grey[900]};
    }
  }
`;

const FooterButton = styled(Button)`
  text-align: center;
  display: block;
  padding: 16px 32px;
  width: 100%;
`;

const PaddedDivider = styled(Divider)`
  margin: 50px 0;
`;

const ExtendedFooter = ({
  getLayoutContentStackData,
  content_id,
  extended_footers,
  theme,
  hideCTA,
  ...other
}) => {
  const stack = extended_footers && extended_footers[content_id];

  useEffect(() => {
    getLayoutContentStackData('extended_footer', content_id);
  }, [content_id, getLayoutContentStackData]);

  if (stack) {
    return (
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <ExtendedFooterContainer data-swiftype-index="false" {...other}>
            <Container>
              <Grid container spacing={0}>
                <ProdFamily item xs={12}>
                  <ProdFamilySVG src={stack.logo.url} alt="logo" />
                  <Typography variant="overline">{stack.title}</Typography>
                </ProdFamily>
                {stack.products.map((product, idx) => {
                  return (
                    <FullHeightGrid item xs={12} md={4} key={idx}>
                      <FooterButton component={Link} to={product.url}>
                        <ProductIcon
                          src={product.logo.url}
                          alt={product.title}
                        />
                        <Typography variant="h6" gutterBottom>
                          {product.title}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {product.description}
                        </Typography>
                      </FooterButton>
                    </FullHeightGrid>
                  );
                })}
              </Grid>
              {!hideCTA && (
                <div>
                  <PaddedDivider />

                  <CallsToAction
                    actionItems={stack.calls_to_action}
                    theme={theme}
                  />
                </div>
              )}
            </Container>
          </ExtendedFooterContainer>
        </ThemeProvider>
      </MuiThemeProvider>
    );
  }
  return null;
};

export default withTheme()(
  connect(
    state => ({
      extended_footers: state.layout.extended_footers
    }),
    {
      getLayoutContentStackData
    }
  )(ExtendedFooter)
);
